import React from 'react'
import { Appearance } from 'common/types/entities/EntityInterface'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'

type DeviceAppearanceProps = {
  desktop: boolean
  mobile: boolean
  update: (appearance: Appearance) => void
}

function DeviceAppearance(props: DeviceAppearanceProps) {
  function toggleDesktop() {
    props.update({
      desktop: !props.desktop,
      mobile: props.desktop ? true : props.mobile,
    })
  }

  function toggleMobile() {
    props.update({
      desktop: props.mobile ? true : props.desktop,
      mobile: !props.mobile,
    })
  }

  return (
    <>
      <GroupTitle>settings_options.device_appearance.label</GroupTitle>
      <CheckboxNew
        wrapperClassName='mt-4'
        label='settings_options.device_appearance.desktop'
        onChange={toggleDesktop}
        checked={props.desktop}
      />
      <CheckboxNew
        wrapperClassName='mt-3'
        label='settings_options.device_appearance.mobile'
        onChange={toggleMobile}
        checked={props.mobile}
      />
    </>
  )
}

export default DeviceAppearance
